import type { ComponentInit } from "@scripts/registry";
import { createTracker } from "@scripts/tracker";

const TRACKER = "[data-fa-nav-menu-tracker]";
const LINK = "[data-fa-nav-menu-link]";
const TRIGGER = "[data-fa-nav-menu-trigger]";
const ITEM = `${LINK}, ${TRIGGER}`;
/* Scoped to the link, not bare: an unscoped match would also find an `aria-current` the CMS put
   on a wrapper, and the tracker would then measure that element instead of the item. */
const CURRENT = `${LINK}[aria-current="page"]`;
const TRACKING = "fa-nav-menu--tracking";

export const initNavMenu: ComponentInit = (root) => {
	const tracker = root.querySelector<HTMLElement>(TRACKER);

	if (!tracker) return;

	/* An open trigger outranks the current page: the megamenu's active item is what the tracker
	   marks while a panel is open. Read from the DOM rather than told, because SiteHeader.mega.ts
	   is a different chunk and the two never import each other. */
	const restTarget = () =>
		root.querySelector<HTMLElement>(`${TRIGGER}[aria-expanded="true"]`) ??
		root.querySelector<HTMLElement>(CURRENT);

	return createTracker({
		root,
		tracker,
		item: ITEM,
		restTarget,
		trackingClass: TRACKING,
		restAttributes: ["aria-expanded"],
	});
};
